<template>
    <div class="progress-compact-container">
        <div class="progress-compact">
            <div class="progress-compact-label">{{progress.title || ''}}</div>
            <span class="progress-success" v-bind:style="{ width: complete }"></span>
            <span class="progress-fail" v-bind:style="{ width: error }"></span>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'ProgressBar',
        props: {
            progress: Object
        },
        data: function () {
            return {}
        },
        computed: {
            total: function () {
                return this.progress.items.length
            },
            complete: function () {
                var self = this
                if (this.total > 0) {
                    return (this.progress.items.filter(datum => {
                        return self.progress.queue.complete.includes(datum.id)
                    }).length / this.total * 100) + '%'
                } else {
                    return '0%'
                }
            },
            error: function () {
                var self = this
                if (this.total > 0) {
                    return (this.progress.items.filter(datum => {
                        return !self.progress.queue.complete.includes(datum.id) && self.progress.queue.error.includes(datum.id)
                    }).length / this.total * 100) + '%'
                } else {
                    return '0%'
                }
            }
        },
        methods: {
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>

</style>



// WEBPACK FOOTER //
// ProgressBar.vue?743a3a6b